import {
  Container,
  MainHeading,
  SubHeading,
  TextContentCont,
  Video,
  VideoContainer,
  VideoInnerContainer,
} from './IntroSection.styles';

const IntroSection: React.FC = () => {
  const isDesktop = window.innerWidth > 600;

  return (
    <Container>
      {isDesktop && (
        <TextContentCont>
          <MainHeading>The first ecosystem for content creators</MainHeading>
          <SubHeading>
            Bridging the gap for creators by offering simple NFT creation,
            discovery, and monetization
          </SubHeading>
        </TextContentCont>
      )}
      <VideoContainer>
        <VideoInnerContainer>
          <Video
            muted
            playsInline
            loop={true}
            autoPlay={true}
            src={
              isDesktop
                ? require('assets/BukuUtilityThroughSocialMedia.mp4')
                : require('assets/BukuUtilityThroughSocialMediaMobile.mp4')
            }
          />
        </VideoInnerContainer>
      </VideoContainer>
    </Container>
  );
};

export default IntroSection;
